import { Injectable } from '@angular/core';
import { StoreBatchWeighingSaveInfo, BatchWeighingStoreCommand } from '../../storage/data-store/model/store-batch-weighing-save-info';
import { StoreBatchWeighing } from '../../storage/data-store/model/registrations/store-batch-weighing';
import { StoreAnimalWeighing } from '../../storage/data-store/model/registrations/store-animal-weighing';
import { StringUuid } from '../../domain/model/uuid/string-uuid';

@Injectable({
  providedIn: 'root',
})
export class SaveToDataStoreMapper {
  constructor() {}

  createUpdatedBatchWeighing(weighingSave: StoreBatchWeighingSaveInfo): Partial<StoreBatchWeighing> {
    const batchWeighingStoreCommand = weighingSave.batchWeighingStoreCommand;
    if (batchWeighingStoreCommand === undefined || batchWeighingStoreCommand === null) {
      throw new Error('BatchWeighingStoreCommand is undefined or null');
    }

    const updatedBatchWeighing = this.makeBatchWeighingUpdatePartial(
      weighingSave.batchWeighingId.asString(),
      batchWeighingStoreCommand
    );
    return updatedBatchWeighing;
  }

  createUpdatedAnimalWeighings(weighingSave: StoreBatchWeighingSaveInfo): Partial<StoreAnimalWeighing>[] {
    const animalWeighings = weighingSave.animalWeighings.map((item) => {
      return this.makeWeighingUpdatePartial(item.id.asString(), item.animalWeights.animals, item.animalWeights.weight);
    });
    return animalWeighings;
  }

  makeBatchWeighingUpdatePartial(id: string, storeCommand: BatchWeighingStoreCommand): Partial<StoreBatchWeighing> {
    const gender = storeCommand.gender;
    const update = storeCommand.updateInfo;
    if (!StringUuid.isValid(id) || gender === undefined || update === undefined) {
      throw new Error(
        `Invalid UUIDs for makeBatchWeighingUpdatePartial. Inputs: id: ${id}, gender: ${gender}, update: ${update}`
      );
    }
    return {
      id: id,
      update: update,
      gender: gender,
    } as Partial<StoreBatchWeighing>;
  }

  makeWeighingUpdatePartial(id: string, inputNumber: number, inputWeight: number): Partial<StoreAnimalWeighing> {
    if (!StringUuid.isValid(id) || inputNumber === undefined || inputWeight === undefined) {
      throw new Error(
        `Invalid inpout for makeWeighingUpdatePartial. Inputs: id: ${id}, number: ${inputNumber}, weight: ${inputWeight}`
      );
    }

    return {
      id: id,
      inputNumber: inputNumber,
      inputWeight: inputWeight,
    } as Partial<StoreAnimalWeighing>;
  }
}
